var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-card',{staticClass:"omapi-statswidget__graph"},[_c('apexchart',{staticClass:"leads-chart",attrs:{"type":"area","width":"100%","height":"250px","options":_vm.chartOptions,"series":[{
			name : '',
			data : _vm.dates.values,
		}]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }